import { render } from "./DialogSelectGenre.vue?vue&type=template&id=07fd3630"
import script from "./DialogSelectGenre.vue?vue&type=script&lang=js"
export * from "./DialogSelectGenre.vue?vue&type=script&lang=js"

import "./DialogSelectGenre.vue?vue&type=style&index=0&id=07fd3630&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__